import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SmoothScroll } from "@/components/common/SmoothScroll";
import { GlowCursor } from "@/components/common/GlowCursor";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { StellaChat } from "@/components/StellaChat";
import { FloatingActions } from "@/components/FloatingActions";

const Home = lazy(() => import("@/pages/Home"));
const Services = lazy(() => import("@/pages/Services"));
const PortfolioPage = lazy(() => import("@/pages/PortfolioPage"));
const PricingPage = lazy(() => import("@/pages/PricingPage"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const PageLoader = () => (
  <div className="flex min-h-screen items-center justify-center bg-ink" data-testid="page-loader">
    <div className="h-10 w-10 animate-spin-slow rounded-full border-2 border-white/10 border-t-gold" />
  </div>
);

function App() {
  return (
    <div className="App">
      <div className="grain" aria-hidden="true" />
      <BrowserRouter>
        <GlowCursor />
        <SmoothScroll>
          <Navbar />
          <main>
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/portfolio" element={<PortfolioPage />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
          <StellaChat />
          <FloatingActions />
        </SmoothScroll>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" richColors closeButton />
    </div>
  );
}

export default App;
